import { render, staticRenderFns } from "./_RejectionReasonDialog.vue?vue&type=template&id=c4f721aa&scoped=true&"
import script from "./_RejectionReasonDialog.vue?vue&type=script&lang=js&"
export * from "./_RejectionReasonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f721aa",
  null
  
)

export default component.exports